import React, { useState } from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';

import {
    AsyncSelectFieldIn,
    renderField,
    renderDayPickerB,
    SelectField,
    renderCurrencyFloat
} from "../../Utils/renderField/renderField";

function DescuentoHoraForm(props) {
    const { modulo, emp, registroDescuento, tipo, lectura,
        datosColaborador, cargo, crear, modificarDescuento,
        sueldo, bonificacion, frecuencia, periodo } = props;

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar descuento por hora' : 'Crear descuento por hora';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver descuento por hora'
    }
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const handleOnChangeEmp = value => {
        datosColaborador(value.value);
    };

    const [horas, setHoras] = useState(0.0);
    const [total, setTotal] = useState(0.0);
    const [horasEd, setHorasEd] = useState(false);
    
    const motivoFalta = [
        { label: "Falta injustificada", value: 1 },
    ];

    const tipoD = [
        { label: "1RA. QUINCENA", value: "1Q" },
        { label: "2DA. QUINCENA", value: "2Q" },
    ];


    return (
        <div>
            <NavbarModulo
                periodoD={periodo}
                modulo={modulo}
                titulo={titulo}
            />
            
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            {(crear === false && editar === false) &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="nombre"
                                            placeholder="Colaborador"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="puestoNombre"
                                            placeholder="Puesto"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Puesto"
                                        />
                                    </div>
                                </div>
                            }
                            {crear === true &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="colaborador"
                                            placeholder="Colaborador..."
                                            className="form-control-find"
                                            component={AsyncSelectFieldIn}
                                            loadOptions={emp}
                                            onChange={handleOnChangeEmp}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className="form-floating">
                                            <input
                                                className = {classNames('form-control')}
                                                type="text"
                                                value = {cargo}
                                                disabled = {true}
                                            />
                                            <label className='form-label'>Puesto</label>
                                        </div>
                                    </div>
                                </div>
                            }
                            {crear === true &&
                                <div className='row mb-2'>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Total"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={sueldo}
                                                name="sueldo"
                                            />
                                            <label className='form-label' htmlFor="sueldo">
                                                Sueldo
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Bonificación"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={bonificacion}
                                                name="bonificacion"
                                            />
                                            <label className='form-label' htmlFor="sueldo">
                                                Bonificación
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <div className="form-floating">
                                            <Field
                                                name="motivo"
                                                disabled={disabled}
                                                options={motivoFalta}
                                                crear={false}
                                                dato={1}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Motivo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {editar === true &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="nombre"
                                            placeholder="Colaborador"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="puestoNombre"
                                            placeholder="Puesto"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Puesto"
                                        />
                                    </div>
                                </div>
                            }
                            {crear === false && editar === false &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            component={renderDayPickerB}
                                            msj="Fecha"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <div className="form-floating">
                                            <Field
                                                name="forma_descuento"
                                                disabled={disabled}
                                                options={tipoD}
                                                crear={crear}
                                                dato={crear === true ? 0 : lectura.forma_descuento}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Forma pago"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="horas"
                                                placeholder="Horas"
                                                className="form-control"
                                                component={renderCurrencyFloat}
                                                msj="Horas"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="total"
                                            placeholder="Total"
                                            className="form-control"
                                            component={renderCurrencyFloat}
                                            msj="Total"
                                        />
                                    </div>
                                    <div className='col-3'>
                                        <div className="form-floating">
                                            <Field
                                                name="motivo"
                                                disabled={disabled}
                                                options={motivoFalta}
                                                crear={false}
                                                dato={1}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Motivo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {crear === true &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            component={renderDayPickerB}
                                            msj="Fecha"
                                        />
                                    </div>
                                    {frecuencia === 'Q' &&
                                        <div className='col-3'>
                                            <div className="form-floating">
                                                <Field
                                                    name="frecuencia"
                                                    disabled={disabled}
                                                    options={tipoD}
                                                    crear={crear}
                                                    dato={crear === true ? 0 : tipo}
                                                    component={SelectField}
                                                    className="form-select"
                                                    msj="Forma descuento"
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="horas"
                                                placeholder="Horas"
                                                className="form-control"
                                                component={renderCurrencyFloat}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        let dato = (parseFloat(sueldo) + parseFloat(bonificacion))/30/8;
                                                        let total = parseFloat(dato) * parseFloat(value);
                                                        setHoras(value);
                                                        setTotal(total);
                                                    }
                                                }}
                                                msj="Horas"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Total"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={total}
                                                name="total"
                                            />
                                            <label className='form-label' htmlFor="total">
                                                Total
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        
                                    </div>
                                </div>
                            }
                            {(crear === false && editar === true) &&
                                <div className='row mb-2'>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Total"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={sueldo}
                                                name="sueldo"
                                            />
                                            <label className='form-label' htmlFor="sueldo">
                                                Sueldo
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Bonificación"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={bonificacion}
                                                name="bonificacion"
                                            />
                                            <label className='form-label' htmlFor="sueldo">
                                                Bonificación
                                            </label>
                                        </div>
                                    </div>
                                    <div className='col-3'>
                                        <div className="form-floating">
                                            <Field
                                                name="motivo"
                                                disabled={disabled}
                                                options={motivoFalta}
                                                crear={false}
                                                dato={1}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Motivo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            {editar === true &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            component={renderDayPickerB}
                                            msj="Fecha"
                                        />
                                    </div>
                                    {(frecuencia === 'Q') &&
                                        <div className='col-3'>
                                            <div className="form-floating">
                                                <Field
                                                    name="forma_descuento"
                                                    disabled={disabled}
                                                    options={tipoD}
                                                    crear={crear}
                                                    dato={crear === true ? 0 : lectura.forma_descuento}
                                                    component={SelectField}
                                                    className="form-select"
                                                    msj="Forma pago"
                                                />
                                            </div>
                                        </div>
                                    }
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="horas"
                                                placeholder="Horas"
                                                className="form-control"
                                                component={renderCurrencyFloat}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        let dato = (parseFloat(sueldo) + parseFloat(bonificacion))/30/8;
                                                        let total = parseFloat(dato) * parseFloat(value)
                                                        setHoras(value);
                                                        setHorasEd(true);
                                                        setTotal(total);
                                                    }
                                                }}
                                                msj="Horas"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <NumberFormat
                                                className={classNames('form-control')}
                                                decimalScale={2}
                                                disabled={true}
                                                placeholder="Total"
                                                fixedDecimalScale
                                                thousandSeparator
                                                value={horasEd === false ? lectura.total : total}
                                                name="total"
                                            />
                                            <label className='form-label' htmlFor="total">
                                                Total
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='row mb-3'>
                                <div className='col-12'>
                                    <Field
                                        name="observaciones"
                                        placeholder="Observaciones"
                                        component={renderField}
                                        className="form-control"
                                        disabled={disabled}
                                        msj="Observaciones"
                                    />
                                </div>
                            </div>
                            <div className='d-flex flex-row mt-3 ml-2'>
                                {crear === true &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => registroDescuento(horas, periodo)}
                                    >
                                        Guardar
                                    </button>
                                }
                                {editar === true &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => modificarDescuento(horasEd === false ? lectura.horas : horas, periodo)}
                                    >
                                        Modificar
                                    </button>
                                }
                                <a
                                    href={`/#/rr_hh/${id_emp[5]}/descuento_hora/${id_emp[7]}`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

DescuentoHoraForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

export default reduxForm({
    form: 'FormDescuentoHora',
})(DescuentoHoraForm);
